import { render, staticRenderFns } from "./serviceori.vue?vue&type=template&id=b6b33f62&"
import script from "./serviceori.vue?vue&type=script&lang=js&"
export * from "./serviceori.vue?vue&type=script&lang=js&"
import style0 from "./serviceori.vue?vue&type=style&index=0&id=b6b33f62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports